import type UseSearchBackPress from './types';

// the back press event is only supported on Android native
const useSearchBackPress: UseSearchBackPress = () => {};

export default useSearchBackPress;
